import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { WithLazy } from "@quintype/components";
import { any, string, number, object } from "prop-types";

import DfpAd from "../../dfp-ad";

import "./ads.m.css";

const AdFreeBase = ({ children, isActivePlan }) => {
  if (isActivePlan) return null;

  return <WithLazy margin="300px">{() => <div>{children}</div>}</WithLazy>;
};

AdFreeBase.propTypes = {
  children: any,
  isActivePlan: number,
};

const mapStateToProps = (state) => ({
  isActivePlan: get(state, ["userReducer", "isActivePlan"], 0),
});

const AdFree = connect(mapStateToProps, null)(AdFreeBase);

const proptypeSet1 = {
  mobile: string,
  desktop: string,
  story: object,
};

const proptypeSet2 = {
  adtype: string,
  story: object,
};

const QuintTopResponsiveContainer = ({ desktop, mobile }) => {
  return (
    <div styleName="quint-top-ad ad">
      <div styleName="desktop">
        <DfpAd adtype={desktop} />
      </div>
      <div styleName="mobile">
        <DfpAd adtype={mobile} />
      </div>
    </div>
  );
};

QuintTopResponsiveContainer.propTypes = proptypeSet1;

const QuintStickyContainer = ({ adtype }) => {
  return (
    <div styleName="">
      <DfpAd adtype={adtype} />
    </div>
  );
};

QuintStickyContainer.propTypes = proptypeSet2;

const Standard337x280Container = ({ adtype, story = {} }) => {
  return (
    <div styleName="standard-337x280 ad" className="standard-337x280">
      <DfpAd adtype={adtype} story={story} />
    </div>
  );
};

Standard337x280Container.propTypes = proptypeSet2;

const Standard300x260Container = ({ adtype }) => {
  return (
    <div styleName="standard-300x260 ad" className="standard-300x260">
      <DfpAd adtype={adtype} />
    </div>
  );
};

Standard300x260Container.propTypes = proptypeSet2;

const Standard337x600Container = ({ adtype }) => {
  return (
    <div styleName="standard-337x600 ad" className="standard-337x600">
      <DfpAd adtype={adtype} />
    </div>
  );
};

Standard337x600Container.propTypes = proptypeSet2;

const StoryTopResponsiveContainer = ({ desktop, mobile, story }) => {
  return (
    <div styleName="story-top-ad ad">
      <div styleName="desktop">
        <DfpAd adtype={desktop} story={story} />
      </div>
      <div styleName="mobile">
        <DfpAd adtype={mobile} story={story} />
      </div>
    </div>
  );
};

StoryTopResponsiveContainer.propTypes = proptypeSet1;

const StoryResponsiveContainer = ({ desktop, mobile, story }) => {
  return (
    <div styleName="story-content ad">
      <div styleName="desktop">
        <DfpAd adtype={desktop} story={story} />
      </div>
      <div styleName="mobile">
        <DfpAd adtype={mobile} story={story} />
      </div>
    </div>
  );
};

StoryResponsiveContainer.propTypes = proptypeSet1;

export {
  AdFree,
  QuintTopResponsiveContainer,
  Standard337x280Container,
  Standard337x600Container,
  Standard300x260Container,
  StoryTopResponsiveContainer,
  StoryResponsiveContainer,
};
